// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../microservices/dash/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar-wrapper[data-v-f669591e]{float:left}.comment-wrapper[data-v-f669591e]{margin-left:44px}.discussion-replies[data-v-f669591e]{padding-left:55px}.reply-spinner-wrapper[data-v-f669591e]{max-width:190px}.reply-icon[data-v-f669591e]{position:relative;top:-1px}", ""]);
// Exports
module.exports = exports;
